export class TreasurySettingsRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid treasury settings request: ${detail}`);
    this.name = 'TreasurySettingsRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
const fail = detail => {throw new TreasurySettingsRequestContractError(detail);};
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const id = value => typeof value === 'string' && /^[a-f\d]{24}$/i.test(value);
const text = (value, max) => typeof value === 'string' && Boolean(value.trim()) && value.trim().length <= max;
export function readTreasurySettingsCursor(value) {
  if (value !== undefined && value !== '' && !id(value)) fail('invalid appointment page.');
  return value;
}
export function readTreasurySettingsLookupRequest(value) {
  if (!text(value, 100)) fail('a valid Bahá’í member number is required.');
  return value;
}
export function readTreasurySettingsActionRequest(action, input) {
  if (!['set_policy', 'grant', 'revoke'].includes(action) || !record(input)) fail('expected a known settings action and object.');
  if (!Number.isSafeInteger(input.revision) || input.revision < 0 || input.confirmDecision !== true || !text(input.note, 1000)) fail('a valid revision and confirmed institutional decision are required.');
  if (input.requestId !== undefined && (typeof input.requestId !== 'string' || !/^[a-zA-Z0-9_-]{8,128}$/.test(input.requestId))) fail('invalid requestId.');
  if (action === 'set_policy') {
    if (typeof input.requireSeparateExpenseAuthoriser !== 'boolean') fail('choose the expense payment authorisation arrangement.');
  } else {
    if (typeof input.role !== 'string' || !['treasurer', 'expense_approver', 'payment_reviewer'].includes(input.role)) fail('choose a treasury appointment.');
    if (action === 'grant') {
      if (!id(input.memberId) || !id(input.userId) || typeof input.memberRevision !== 'string' || !Number.isFinite(Date.parse(input.memberRevision))) fail('find and verify the member before granting an appointment.');
    } else if (!id(input.assignmentId)) fail('choose the appointment to revoke.');
  }
  return input;
}
export function readTreasurySettingsRecoveryIdentifier(value) {
  if (typeof value !== 'string' || !/^treasury-settings-recovery_[a-f\d]{24}_[a-f\d]{24}_[a-zA-Z0-9_-]{8,48}$/i.test(value)) fail('invalid recovery reference.');
  return value;
}
